import { myBuddies, allUsers, allGroups } from "./users-groups";

export function getBuddyPromise(username) {
  const promise = new Promise(function (resolve, reject) {
    let isBuddy = false;
    for (let i = 0; i < myBuddies.data.length; i++) {
      if (myBuddies.data[i].data.userPreferences.username === username) {
        isBuddy = true;
        break;
      }
    }
    setTimeout(() => {
      if (isBuddy) {
        return resolve(true);
      } else {
        return reject(new Error("Not found"));
      }
    }, 1000);
  });
  return promise;
}

export function getUserPromise(username) {
  const promise = new Promise(function (resolve, reject) {
    let isUser = false;
    let userObject;
    for (let i = 0; i < allUsers.data.length; i++) {
      if (allUsers.data[i].data.userPreferences.username === username) {
        isUser = true;
        userObject = allUsers.data[i].data;
        break;
      }
    }
    setTimeout(() => {
      if (isUser) {
        return resolve(userObject);
      } else {
        return reject(new Error("Not found"));
      }
    }, 1000);
  });
  return promise;
}

export function getGroupsPromise(username) {
  const promise = new Promise(function (resolve, reject) {
    let isGroup = false;
    let groupObject;
    for (let i = 0; i < allGroups.data.length; i++) {
      if (allGroups.data[i].data.userPreferences.username === username) {
        isGroup = true;
        groupObject = allGroups.data[i].data;
        break;
      }
    }
    setTimeout(() => {
      if (isGroup) {
        return resolve(groupObject);
      } else {
        return reject(new Error("Not found"));
      }
    }, 1000);
  });
  return promise;
}
